<template>
  <div class="page_finance">
    <h1>Finance</h1>
    <section class="info">
      <h2>Informace</h2>
      <div class="qr" v-html="paymentQrCodeSvg"></div>
      <h4>Číslo účtu: <a href="https://ib.fio.cz/ib/transparent?a=6051726730" target="_blank">6051726730/2010</a></h4>
      <h4>variabilní symbol: <strong>číslo hlídky</strong></h4>
    </section>
    <h2>Cena - {{ price_total | currency }}</h2>
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Položka</th>
          <th>Počet</th>
          <th>Cena celkem</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="master"
          :class="{ rolled: showAllParticipants }"
          @click="showAllParticipants = !showAllParticipants"
        >
          <th>
            <i class="fa fa-chevron-right"></i>
          </th>
          <th>Účastníci</th>
          <th>{{ Object.keys(myFinanceParticipant).length }}</th>
          <th>{{ price_participants | currency }}</th>
        </tr>
        <template v-if="showAllParticipants">
          <tr v-for="(participant, id) in myFinanceParticipant" :key="id">
            <td></td>
            <td>{{ participant | participant_name }}</td>
            <td></td>
            <td>{{ getPrice(participant) | currency }}</td>
          </tr>
        </template>

        <tr class="master" :class="{ rolled: showAllAcc }" @click="showAllAcc = !showAllAcc">
          <th>
            <i class="fa fa-chevron-right"></i>
          </th>
          <th>Ubytování</th>
          <th>{{ accCount }}</th>
          <th>{{ price_acc | currency }}</th>
        </tr>
        <template v-if="showAllAcc">
          <tr v-for="(acc, accId) in myAccommodation" :key="accId">
            <td></td>
            <td>{{ accId | cz_accommodation }}</td>
            <td data-holder="count">{{ acc.amount }}</td>
            <td>{{ acc.price | currency }}</td>
          </tr>
        </template>

        <tr class="master" :class="{ rolled: showShirts }" @click="showShirts = !showShirts">
          <th>
            <i class="fa fa-chevron-right"></i>
          </th>
          <th>Trička</th>
          <th data-holder="count">{{ shirtsCount }}</th>
          <th>{{ price_shirts | currency }}</th>
        </tr>
        <template v-if="showShirts">
          <tr v-for="(count, size) in anyShirts" :key="size">
            <td></td>
            <td>{{ size | cz_size }}</td>
            <td>{{ count }}</td>
            <td>{{ count * config.shirtPrice }}</td>
          </tr>
        </template>

        <tr class="master" :class="{ rolled: showAllOther }" @click="showAllOther = !showAllOther">
          <th>
            <i class="fa fa-chevron-right"></i>
          </th>
          <th>Ostatní</th>
          <th data-holder="count">{{ Object.keys(priceModifiers).length }}</th>
          <th>{{ price_other | currency }}</th>
        </tr>
        <template v-if="showAllOther">
          <tr v-for="(item, id) in priceModifiers" :key="id">
            <td></td>
            <td>{{ item.message }}</td>
            <td data-holder="count"></td>
            <td>{{ item.amount | currency }}</td>
          </tr>
        </template>
      </tbody>
    </table>
    <h2>Platby - {{ paid | currency }}</h2>
    <table>
      <thead>
        <tr>
          <th>Datum platby</th>
          <th>Zpráva</th>
          <th>Částka</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(payment, paymentId) in payments" :key="paymentId">
          <td>{{ payment.date | cz_datetime }}</td>
          <td>{{ payment.message }}</td>
          <td>{{ payment.amount | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { _ } from "../extend";
import { price } from "../rr_utils";

export default {
  name: "finance",
  computed: {
    ...mapState(["payments", "priceModifiers", "config", "paymentQrCodeSvg"]),
    ...mapGetters([
      "myFinanceParticipant",
      "myAccommodation",
      "price_participants",
      "price_acc",
      "price_shirts",
      "price_other",
      "price_total",
      "paid"
    ]),
    accCount() {
      return _.sum(this.myAccommodation, acc => acc.amount);
    },
    shirtsCount() {
      return _.sum(this.$store.state.shirts, shirtCount => shirtCount);
    },
    anyShirts() {
      return _.filter(this.$store.state.shirts, shirtCount => shirtCount > 0);
    }
  },
  data: () => ({
    showAllParticipants: false,
    showAllAcc: false,
    showShirts: false,
    showAllOther: false
  }),
  methods: {
    getPrice(participant) {
      return price.participant(this.$store.state, participant);
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_constants
@import ../sass/_components

.page_finance
  margin: 0 auto
  width: 100%
  max-width: $w-content
  a
    @include button-secondary()
  h2
    margin-top: 2rem
  table
    margin: 1rem 0 1rem 0
    width: 100%
    border-spacing: 0
    th
      font-weight: bold
    th, td
      padding: .5rem 1rem
      text-align: center
    tr:nth-child(2n)
      background-color: $bc-secondary-light
    thead tr th
      padding: 10px 20px
      color: #fff
      background-color: $bc-primary
    tbody
      .master
        cursor: pointer
        transition: background-color .5s
        th
          transition: transform .5s
        &:hover, &.rolled
          background-color: $bc-secondary
          th:first-child
            transform: rotate(90deg)
  .info
    display: grid
    .qr
      grid-column: 2
      grid-row: 1/5
      justify-self: end
      svg
        height: 200px
</style>